import React from "react";

import { ColumnProps } from "../../../../../../../../types/models";

const PostionCatalogColumns: ColumnProps[] = [
  {
    title: "STT",
    key: "index",
    show: true,
    dataIndex: "index",
    render(_, __, index) {
      return <>{index + 1}</>;
    },
    align: "center",
    fixed: "left",
    width: 30,
    isResizable: true,
  },

  {
    title: "Mã chức vụ",
    key: "maChucVu",
    show: true,
    dataIndex: "maChucVu",
    width: 50,
    align: "left",
    isResizable: true,
  },
  {
    title: "Tên chức vụ",
    key: "tenChucVu",
    show: true,
    dataIndex: "tenChucVu",
    width: 150,
    align: "left",
    isResizable: true,
  },
  {
    title: "Ghi chú",
    key: "ghiChu",
    show: true,
    dataIndex: "ghiChu",
    width: 150,
    align: "left",
    isResizable: true,
  },

  {
    title: "Thao tác",
    dataIndex: "action",
    key: "action",
    editable: true,
    width: 50,
    show: true,
    align: "center",
  },
];

export { PostionCatalogColumns };
